import React, { Component } from 'react';
import { authentication } from '../services/Authentication';
import socketIOClient from "socket.io-client";
import {
    MessageBox,
    ChatItem,
    ChatList,
    SystemMessage,
    MessageList,
    Input,
    Button,
    Avatar,
    Navbar,
    SideBar,
    Dropdown,
    Popup,
} from 'react-chat-elements';
// RCE CSS
import 'react-chat-elements/dist/main.css';
import { config } from '../Constants';
import helpers from '../Function';
import $ from "jquery"

export default class ChatRoom extends Component {
    componentDidMount() {
        const { endpoint, jwt, user_id } = this.state;
        helpers.checklogin(jwt);
        const socket = socketIOClient(endpoint);
        socket.emit('joinroomWeb', { room: 'value', user_name: user_id })
    }

    constructor(props) {
        super(props);
        console.log(this.props)
        const { name, user_id, user_type, jwt, user_permission } = authentication.currentUserValue;

        this.state = {
            endpoint: "http://127.0.0.1:5000",
            jwt: jwt,
            user_permission: user_permission,
            user_id: user_id
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");
    }

    render() {
        return (
            <div className='content-wrapper'>
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark"></h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                <section className="content">
                    <div className="row">
                        <div className="col-2">
                            <div className="card">
                                <ChatList
                                    className='chat-list'
                                    dataSource={[
                                        {
                                            avatar: ``,
                                            title: 'Facebook',
                                            subtitle: ''
                                        }
                                    ]} />
                            </div>
                        </div>
                        <div className="col-10">
                            <div className="card text-center">
                                <div className="card-header">
                                    {"PROJECT NAME"}
                                </div>
                                <div className="card-body" style={{ backgroundColor: "lightblue" }}>
                                    <MessageList
                                        className='message-list'
                                        lockable={true}
                                        toBottomHeight={'100%'}
                                        dataSource={[
                                            {
                                                "position": "left",
                                                "type": "photo",
                                                "title": "กฤษณา ดวงจินดา 122/19",
                                                "text": "",
                                                "date": "2020-03-30T07:11:53.469Z",
                                                "view": "list",
                                                "data": {
                                                    "uri": "http://58.137.160.177:5000/chat/images/zngyeiyra1585552313405",
                                                    "status": {
                                                        "click": false
                                                    },
                                                    "size": "100MB",
                                                    "width": 300,
                                                    "height": 300
                                                }
                                            },
                                            {
                                                "position": "left",
                                                "type": "text",
                                                "title": "กฤษณา ดวงจินดา 122/19",
                                                "text": "hello",
                                                "date": "2020-03-30T07:11:40.545Z",
                                                "view": "list"
                                            },
                                            {
                                                "position": "left",
                                                "type": "text",
                                                "title": "กฤษณา ดวงจินดา 122/19",
                                                "text": "สวัสดีคับ",
                                                "date": "2020-03-30T07:11:07.810Z",
                                                "view": "list"
                                            }
                                        ]} />
                                </div>
                                <div className="card-footer text-muted">
                                    <Input
                                        placeholder="message"
                                        defaultValue=""
                                        ref='input'
                                        rightButtons={
                                            <Button
                                                text='Enter' />
                                        } />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
